import singer from "../../assets/singernobg.png";
import coins from "../../assets/coinsinphone.png";
import crypto from "../../assets/cryptos-removebg-preview.png";
import investnow from "../../assets/whbg.jpg";
// import balance from "../../assets/walletballance-removebg-preview.png";
import success from "../../assets/success.jpg";
import {
	domain,
	investmentPlans,
	numberData,
	userTestimonial,
	tradingPriviledges,
	whyChooseUs,
} from "../../data";
// import ReactPlayer from "react-player";
import { useEffect, useState } from "react";
import axios from "../../api/axios";
import ScaleLoader from "react-spinners/ScaleLoader";
import { errorMsg } from "../../helper/errorMsg";
import { Link } from "react-router-dom";
import { MdSecurity } from "react-icons/md";
import { SiHackaday } from "react-icons/si";
import { BsCurrencyExchange } from "react-icons/bs";
import { GiShieldReflect } from "react-icons/gi";
import { FaArrowRightLong } from "react-icons/fa6";
import experts from "../../assets/experts.jpg";
import security from "../../assets/security.jpg";
import trade from "../../assets/mockphoner.jpg";
import { IoStar } from "react-icons/io5";
import { SiYoutubemusic } from "react-icons/si";
import { IoSearchSharp } from "react-icons/io5";
import belief from "../../assets/illustrate.jpg";
import company from "../../assets/company.jpg";
import tradebg from "../../assets/tradebg.jpg";
// import tradeTime from "../../assets/tradetime.jpg";
import tradepc from "../../assets/tradepcnobg.png";
import connect from "../../assets/connection.jpg";
import pay from "../../assets/pay.jpg";
import startnow from "../../assets/startnow.jpg";
import { motion } from "framer-motion";
import { TickerTape } from "react-ts-tradingview-widgets";
import ChatUtil from "../UtilComponents/ChatUtil";
import { Typography, Box } from "@mui/material";
import NumberUtil from "./NumberUtil";
// import TradeTypes from "./TradeTypes";
import TabLand from "./TabLand";
import NeedHelp from "./NeedHUtil";
import AllMarkets from "./AllMarkets";
import Testimonials from "./Testimonials";
import NewTestimonial from "./NewTestimonials";
import needhelp from "../../assets/needhelp.jpg";
import ready from "../../assets/ready.jpg";
import TradeTestimonials from "./TradeTestimonial";
import InvestmentPlan from "./InvestmentPlan";
import CryptoGist from "./CryptoGist";
import { FaGift } from "react-icons/fa6";
import TrendingToken from "./TrendingToken";
import Votingcarousel from "./Votingcarousel";
import Whyhoooseus from "./Whychooseus";
import Safeguardassets from "./Safeguardassets";
import { FaWhatsappSquare } from "react-icons/fa";
import { IoLogoWhatsapp } from "react-icons/io";
import NewLandingUi from "./NewLandingUi";
import MiningAndTradingPlan from "./MiningAndTradingPlan";
import QAndA from "./QandA";
import PowerfulTool from "./PowerfulTool";
import Security from "./Security";

export default function LandingPage() {
	const [err, setErr] = useState("");
	const [loading, setLoading] = useState(false);
	const [allSongs, setAllsongs] = useState();
	const [width, setWidth] = useState(window.innerWidth);
	const [searchData, setSearchData] = useState("");

	useEffect(() => {
		const script = document.createElement("script");
		script.src = "https://embed.tawk.to/68fe5c571e32b2194a785e65/1j8gphe79";

		script.async = true;
		document.body.appendChild(script);

		return () => {
			document.body.removeChild(script);
		};
	}, []);

	const settings = {
		dots: false,
		infinite: true,
		speed: 2000,
		slidesToShow: 3,
		slidesToScroll: 3,
		autoplay: true,
		autoplaySpeed: 2000,
		className: "flex ",
	};

	// FOR CAROUSELS DIFFERENT SCREEN VIEWS

	const responsive = {
		desktop: {
			breakpoint: { max: 3000, min: 1024 },
			items: 3,
		},
		tablet: {
			breakpoint: { max: 1024, min: 464 },
			items: 2,
		},
		mobile: {
			breakpoint: { max: 464, min: 0 },
			items: 1,
		},
	};
	const content = (
		<main className="min-h-screen w-full   mx:bg-red-500 bg-black  text-white flex flex-col overflow-hidden  z-0    ">
			{/* whatsapp support */}
			<Link
				style={{ zIndex: 70 }}
				to="https://wa.me/+15207634388"
				className=" w-[4rem] h-[4rem]   rounded-full  fixed   bottom-[7rem]  right-[1rem]  z-60   text-[2rem]  grid place-content-center  bg-green-600">
				<IoLogoWhatsapp className="text-[2.5rem]   z-60 " />
			</Link>
			<motion.section
				// animate={{ opacity: 0, y: 120 }}
				// whileInView={{ opacity: 1, y: 0 }}
				// transition={{ duration: 2 }}
				className="min-h-[8rem]    w-full    my-[2rem]  mx-auto  ">
				<NewLandingUi />
			</motion.section>

			{/* number that made us */}

			{/* end of number util */}
			{/* <Box sx={{ my: 0 }}>
				<Link
					to="/en/register"
					className=" text-white  capitalize flex justify-center  items-center gap-[0.5rem] min w-[95%]  md:w-[60%]  px-[1.2rem]  py-[0.5rem] mx-auto  bg-blue-600  rounded-full  text-[0.9rem]  text-center  font-bold  tracking-wide   ">
					<FaGift className="inline-block" /> Sign Up & get 2,300 USDT
				</Link>
			</Box> */}

			{/* trading widget util */}
			<Box
				variant="section"
				sx={{ width: "100%", marginY: "0.2rem", marginX: "auto" }}>
				<TickerTape colorTheme="light"></TickerTape>
			</Box>
			{/* trading ticker tape */}

			{/* end of trading ticker tape */}
			{/* powerfilt tool */}
			<PowerfulTool />
			{/*end of powerfilt tool */}
			{/* <Security /> */}
			{/* all your market in one place */}

			{/* <motion.section
				viewport={{ once: true }}
				animate={{ opacity: 0, y: 120 }}
				whileInView={{ opacity: 1, y: 0 }}
				transition={{ duration: 2 }}
				className=" lg:max-w-[85%]  lg:mx-auto      lg:px-[2rem]   flex  flex-col  lg:flex-row  px-[1rem]  justify-center  items-center  gap-[1rem]  lg:gap-[0.5rem]  ">

				<Votingcarousel />
			</motion.section> */}
			{/* <TrendingToken /> */}
			<motion.section
				viewport={{ once: true }}
				animate={{ opacity: 0 }}
				whileInView={{ opacity: 1 }}
				transition={{ duration: 2 }}
				className="flex  flex-col justify-center  items-center  gap-[1rem]  lg:flex-row-reverse">
				{/* <AllMarkets /> */}
				{/* <Whyhoooseus /> */}
			</motion.section>

			{/* FIRST */}

			{/* <motion.section
				viewport={{ once: true }}
				animate={{ opacity: 0 }}
				whileInView={{ opacity: 1 }}
				transition={{ duration: 2 }}>
				<MiningAndTradingPlan />
			</motion.section> */}

			{/* INVESTMENT PLANS */}
			<motion.section
				className="pt-[3rem] pb-[13rem]  mb-[2rem]  bg-gradient-to-b from-white from-95% to-black    rounded-t-xl  w-full  relative  "
				viewport={{ once: true }}
				animate={{ opacity: 0, y: 120 }}
				whileInView={{ opacity: 1, y: 0 }}
				transition={{ duration: 2 }}>
				<div className="custom-shape-divider-top-1760158780">
					<svg
						data-name="Layer 1"
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 1200 120"
						preserveAspectRatio="none">
						<rect x="1200" height="3.6"></rect>
						<rect height="3.6"></rect>
						<path
							d="M0,0V3.6H580.08c11,0,19.92,5.09,19.92,13.2,0-8.14,8.88-13.2,19.92-13.2H1200V0Z"
							className="shape-fill"></path>
					</svg>
				</div>
				<InvestmentPlan />
				<div className="custom-shape-divider-bottom-1760160128">
					<svg
						data-name="Layer 1"
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 1200 120"
						preserveAspectRatio="none">
						<path
							d="M0,0V7.23C0,65.52,268.63,112.77,600,112.77S1200,65.52,1200,7.23V0Z"
							className="shape-fill"></path>
					</svg>
				</div>
				<div className="bg-red-500"></div>
			</motion.section>

			{/* SECOND */}
			{/* <motion.section
				viewport={{ once: true }}
				animate={{ opacity: 0 }}
				whileInView={{ opacity: 1 }}
				transition={{ duration: 2 }}>
				<Safeguardassets />
			</motion.section> */}

			<motion.section
				className="w-[90%]  mx-auto my-[2rem] "
				viewport={{ once: true }}
				animate={{ opacity: 0 }}
				whileInView={{ opacity: 1 }}
				transition={{ duration: 2 }}>
				<TabLand />
			</motion.section>

			{/* Q AND A */}
			<motion.section
				viewport={{ once: true }}
				animate={{ opacity: 0, y: 120 }}
				whileInView={{ opacity: 1, y: 0 }}
				transition={{ duration: 2 }}
				className=" ">
				<QAndA />
			</motion.section>

			{/* <motion.section
				animate={{ opacity: 0, y: 120 }}
				whileInView={{ opacity: 1, y: 0 }}
				transition={{ duration: 3 }}>
				<NumberUtil />
			</motion.section> */}
			{/* <section className=" w-full  text-black  bg-white">
				<section className="w-full flex flex-col text-center  gap-5 lg:flex-row justify-center  items-center  p-4  ">
					<motion.h5
						animate={{ opacity: 0, y: 80 }}
						whileInView={{ opacity: 1, y: 0 }}
						transition={{ duration: 1.5 }}
						viewport={{ once: true }}
						className="text-[1.2rem]  text-center  mx-auto    tracking-wider p-[0.3rem] ">
						Start your earning journey by choosing your preferred plan.
					</motion.h5>
					<img src={ready} alt="experts" className="" />
				</section>
				<motion.section
					animate={{ opacity: 0, y: 50 }}
					whileInView={{ opacity: 1, y: 0 }}
					transition={{ duration: 1.5 }}
					viewport={{ once: true }}
					className="w-[98%] mx-auto my-3        grid  gap-4   grid-cols-2 ">
					{investmentPlans.map((data) => (
						<div
							key={data.id}
							className=" w-full  md:w-[90%]  md:mx-auto min-h-full  bg-blue-100     flex flex-col    gap-3 p-1  justify-around  items-center ">
							<h3 className="text-[1.1rem] tracking-wide  font-bold  text-black">
								{data.name}
							</h3>
							<motion.ul
								// animate={{ opacity: 0, x: 50 }}
								// whileInView={{ opacity: 1, x: 0 }}
								// transition={{ duration: 1.5 }}
								// viewport={{ once: true }}
								className=" min-w-full  h-full flex  gap-2 flex-col justify-around  p-[0.5rem]   items-center">
								<li className="li-plan-style">
									<span className="plan-field-style">Captital back:</span>
									<span className="plan-value-style">{data.CB}</span>
								</li>
								<li className="li-plan-style">
									<span className="plan-field-style">Min Amount:</span>
									<span className="plan-value-style">{data.minAmount}</span>
								</li>
								<li className="li-plan-style">
									<span className="plan-field-style">Max Amount:</span>
									<span className="plan-value-style">{data.maxAmount}</span>
								</li>
								<li className="li-plan-style">
									<span className="plan-field-style">ROI:</span>
									<span className="plan-value-style">{data.ROI}</span>
								</li>
								<li className="li-plan-style">
									<span className="plan-field-style">Referal Commission:</span>
									<span className="plan-value-style">{data.RC}</span>
								</li>
							</motion.ul>

							<Link
								className="bg-gradient-to-r  px-[1rem]  py-[0.3rem]    text-center text-[1.1rem] tracking-wide  font-serif  bg-red-800  my-2   text-white shadow-inner shadow-gray-500"
								to="en/register">
								Choose Plan
							</Link>
						</div>
					))}
				</motion.section>
			</section> */}

			{/* CREATE AN ACCOUNT  */}

			{/* <section className="w-[99%]  p-[1rem] border-r-4     bg-white  text-black   my-[2rem]  mx-auto  "> */}
			{/* <h2 className="min-w-fit  my-[1rem] text-left  sm:text-center mx-auto  text-[1.5rem]  font-serif">
          Legal Company
        </h2> */}

			{/* <article className=" w-full  sm:w-[99%]     mx-auto  flex flex-col sm:flex-row justify-around  items-center  gap-3    "> */}
			{/* <div className="w-full h-full  ">
            <img src={belief} alt="belief" className="w-full  h-full" />
          </div> */}
			{/* <div className=" w-full   flex flex-col  justify-center  items-center gap-3 ">
						<NeedHelp />
					</div> */}

			{/* <div className="w-full   hidden  sm:block    border-none rounded-full bg-gradient-to-b  from-transparent  from-70%  to-gray-300   ">
						<img
							src={needhelp}
							alt="tradepc"
							className="w-full   rounded-tl-[2rem]  h-[35rem]"
						/>
					</div> */}
			{/* </article> */}
			{/* </section> */}

			{/* TESTIMONIALS */}

			<TradeTestimonials />

			{/* <Testimonials /> */}
		</main>
	);

	return content;
}
